import { render, staticRenderFns } from "./TotalLiabilityChartWidget.vue?vue&type=template&id=328c8382&"
import script from "./TotalLiabilityChartWidget.vue?vue&type=script&lang=js&"
export * from "./TotalLiabilityChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports